(function () {
  'use strict';

  function updateHeader() {
    var scrolled = window.scrollY > 24;
    document.documentElement.classList.toggle('cpx-v5-scrolled', scrolled);
    document.body.classList.toggle('cpx-v5-scrolled', scrolled);
  }

  function updateAnnouncementHeight() {
    var bar = document.querySelector('.shopify-section-announcement-bar-container');
    var height = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--cpx-v5-announcement-h', height + 'px');
  }

  function initReveal() {
    var nodes = document.querySelectorAll('[data-cpx-v5-reveal]');
    if (!nodes.length) return;
    nodes.forEach(function (node) { node.setAttribute('data-cpx-v5-reveal', ''); });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      nodes.forEach(function (node) { node.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    nodes.forEach(function (node) { observer.observe(node); });
    window.setTimeout(function () {
      nodes.forEach(function (node) {
        if (!node.classList.contains('is-visible')) node.classList.add('is-visible');
      });
      observer.disconnect();
    }, 1200);
  }

  if (document.documentElement.classList.contains('template-index') || document.body.classList.contains('template-index')) {
    updateAnnouncementHeight();
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
    window.addEventListener('resize', updateAnnouncementHeight, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
}());
